export const isStickyLeaseTopbar = (galleryPosition: number) => {
  const pixelsToScrollToShowStickyHeader = galleryPosition

  let isSticky = window.scrollY > pixelsToScrollToShowStickyHeader
  return isSticky
}

window.isStickyLeaseTopbar = isStickyLeaseTopbar
